module.exports = __webpack_public_path__ + "img/2A4BA7_1B2D44_1F3768_233C81-256px.1689102b.png";